var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-top",attrs:{"type":"button","aria-label":"Back to top"},on:{"click":_vm.scrollToTop}},[_vm._v(" ↑ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }